import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { columnMultiSelect, columnSelect, hasColumn } from '@/constants/fields';

const TableWrapper = ({
  attached,
  celled,
  children,
  className,
  columns = [],
  selectable,
  solid,
  sticky,
}) => (
  <Table
    unstackable
    celled={celled}
    striped={!solid}
    compact
    selectable={selectable}
    attached={attached}
    className={clsx(
      'aridhia-table-wrapper',
      className,
      sticky && 'sticky-header',
    )}
    definition={hasColumn(columns, [columnMultiSelect, columnSelect])}
  >
    {children}
  </Table>
);

export default TableWrapper;
